/** @format */

import React, { useState, useEffect, useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "../../css/NavbarMobile.css";

/////////////   Redux  //////////////
import { saveLanguageWeb } from "../store/LanguageSlice";
import { useSelector, useDispatch } from "react-redux";

import Logo_Traffy from "../../assets/Logo_Traffy.png";
import Fondue_App_Icon from "../../assets/Fondue_App_Icon.png";

export default function AboutUsEN(props) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "1rem",
      }}>
      <img
        src={Logo_Traffy}
        style={{ height: "66px", width: "auto", marginTop: "3rem" }}
      />

      <div
        style={{
          backgroundColor: "#F3EDF7",
          borderRadius: "8px",
          padding: "1rem",
          marginTop: "2rem",
          boxShadow: "0px 2px 6px 2px #00000026",
        }}>
        <p
          style={{
            fontFamily: "Noto Sans Thai",
            fontSize: "14px",
            fontWeight: "600",
            marginBottom: "0.2rem",
          }}>
          NATIONAL SCIENCE AND TECHNOLOGY DEVELOPMENT AGENCY
        </p>
        <p
          style={{
            fontFamily: "Noto Sans Thai",
            fontSize: "14px",
            fontWeight: "400",
          }}>
          111 Thailand Science Park, Phahonyothin Road, Khlong Nueng, Khlong
          Luang, Pathum Thani 12120 Thailand
        </p>
      </div>

      <div
        style={{
          backgroundColor: "#F3EDF7",
          borderRadius: "8px",
          padding: "1rem",
          marginTop: "2rem",
          boxShadow: "0px 2px 6px 2px #00000026",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "2rem",
        }}>
        <a
          href="https://info.traffy.in.th/Help-Center-f7de9a3f310b4bcd8f307dfced4926b2"
          target="_blank"
          rel="noreferrer"
          style={{
            display: "flex",
            gap: "0.5rem",
            textDecoration: "none",
            color: "#000",
          }}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12ZM8.244 9.0495H9.4815C9.6885 9.0495 9.8535 8.88 9.8805 8.6745C10.0155 7.6905 10.6905 6.9735 11.8935 6.9735C12.9225 6.9735 13.8645 7.488 13.8645 8.7255C13.8645 9.678 13.3035 10.116 12.417 10.782C11.4075 11.5155 10.608 12.372 10.665 13.7625L10.6695 14.088C10.6711 14.1864 10.7113 14.2803 10.7814 14.3493C10.8516 14.4183 10.9461 14.457 11.0445 14.457H12.261C12.3605 14.457 12.4558 14.4175 12.5262 14.3472C12.5965 14.2768 12.636 14.1815 12.636 14.082V13.9245C12.636 12.8475 13.0455 12.534 14.151 11.6955C15.0645 11.001 16.017 10.23 16.017 8.6115C16.017 6.345 14.103 5.25 12.0075 5.25C10.107 5.25 8.025 6.135 7.8825 8.679C7.88045 8.72744 7.88832 8.77579 7.90565 8.82107C7.92297 8.86636 7.94937 8.90762 7.98323 8.94232C8.01709 8.97703 8.05769 9.00444 8.10254 9.02287C8.14738 9.0413 8.19552 9.05036 8.244 9.0495ZM11.7315 18.714C12.6465 18.714 13.275 18.123 13.275 17.3235C13.275 16.4955 12.645 15.9135 11.7315 15.9135C10.8555 15.9135 10.218 16.4955 10.218 17.3235C10.218 18.123 10.854 18.714 11.7315 18.714Z"
              fill="#65558F"
            />
          </svg>
          <p>Help Center</p>
        </a>
        <a
          href="https://www.traffy.in.th/"
          target="_blank"
          rel="noreferrer"
          style={{
            display: "flex",
            gap: "0.5rem",
            textDecoration: "none",
            color: "#000",
          }}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_34_188)">
              <path
                d="M12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0C8.8174 0 5.76516 1.26428 3.51472 3.51472C1.26428 5.76516 0 8.8174 0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C5.76516 22.7357 8.8174 24 12 24ZM13.395 9.882L11.895 16.9395C11.79 17.4495 11.9385 17.739 12.351 17.739C12.642 17.739 13.0815 17.634 13.38 17.37L13.248 17.994C12.8175 18.513 11.868 18.891 11.0505 18.891C9.996 18.891 9.5475 18.258 9.8385 16.9125L10.9455 11.7105C11.0415 11.271 10.9545 11.112 10.515 11.0055L9.8385 10.884L9.9615 10.3125L13.395 9.882ZM12 8.25C11.6022 8.25 11.2206 8.09196 10.9393 7.81066C10.658 7.52936 10.5 7.14782 10.5 6.75C10.5 6.35218 10.658 5.97064 10.9393 5.68934C11.2206 5.40804 11.6022 5.25 12 5.25C12.3978 5.25 12.7794 5.40804 13.0607 5.68934C13.342 5.97064 13.5 6.35218 13.5 6.75C13.5 7.14782 13.342 7.52936 13.0607 7.81066C12.7794 8.09196 12.3978 8.25 12 8.25Z"
                fill="#65558F"
              />
            </g>
            <defs>
              <clipPath id="clip0_34_188">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <p>traffy.in.th</p>
        </a>

        <a
          href="https://line.me/R/ti/p/%40155yjrwo"
          target="_blank"
          rel="noreferrer"
          style={{
            display: "flex",
            gap: "0.5rem",
            textDecoration: "none",
            color: "#000",
          }}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 0C18.6165 0 24 4.58429 24 10.2202C24 12.4761 23.1675 14.507 21.4275 16.5079C18.9105 19.5494 13.281 23.2536 12 23.8204C10.755 24.3714 10.899 23.5103 10.956 23.1702L10.9605 23.1419L11.1315 22.0635C11.172 21.7423 11.214 21.2433 11.0925 20.9253C10.9575 20.5742 10.4265 20.3916 10.0365 20.3035C4.269 19.5053 0 15.2721 0 10.2202C0 4.58429 5.385 0 12 0ZM7.533 12.0999H5.2455V7.74229C5.2455 7.67743 5.22105 7.6152 5.17749 7.56919C5.13393 7.52318 5.0748 7.49712 5.013 7.49671H4.17C4.13927 7.49671 4.10884 7.50306 4.08045 7.5154C4.05206 7.52774 4.02627 7.54583 4.00454 7.56864C3.98281 7.59144 3.96557 7.61852 3.95381 7.64831C3.94205 7.67811 3.936 7.71004 3.936 7.74229V13.2302C3.936 13.2948 3.9615 13.3562 4.002 13.3987V13.4002L4.005 13.4034L4.008 13.4065C4.02935 13.4286 4.05468 13.4459 4.0825 13.4575C4.11032 13.4692 4.14006 13.4748 4.17 13.4742H7.533C7.662 13.4742 7.7655 13.364 7.7655 13.2287V12.3471C7.7657 12.3148 7.75984 12.2828 7.74826 12.253C7.73669 12.2231 7.71961 12.1959 7.69802 12.1729C7.67644 12.15 7.65075 12.1317 7.62243 12.1192C7.59412 12.1067 7.56373 12.1001 7.533 12.0999ZM8.7195 7.49671C8.65744 7.49671 8.59792 7.52258 8.55404 7.56864C8.51015 7.6147 8.4855 7.67716 8.4855 7.74229V13.2302C8.4855 13.3656 8.5905 13.4742 8.7195 13.4742H9.5625C9.6915 13.4742 9.795 13.364 9.795 13.2302V7.74229C9.795 7.67743 9.77055 7.6152 9.72699 7.56919C9.68343 7.52318 9.6243 7.49712 9.5625 7.49671H8.7195ZM14.514 7.49671C14.4519 7.49671 14.3924 7.52258 14.3485 7.56864C14.3047 7.6147 14.28 7.67716 14.28 7.74229V11.001L11.8845 7.60691L11.865 7.58329L11.85 7.56598L11.8455 7.56125L11.829 7.54708L11.82 7.54079L11.8155 7.53764L11.808 7.53292L11.796 7.52504H11.793L11.7885 7.5219L11.7735 7.5156L11.7675 7.51245L11.7525 7.50773H11.7495L11.745 7.50615L11.7315 7.503H11.7225L11.718 7.50143H11.712L11.709 7.49986H10.848C10.7862 7.49985 10.7269 7.52551 10.6831 7.57123C10.6392 7.61695 10.6144 7.67901 10.614 7.74387V13.2318C10.614 13.3672 10.719 13.4758 10.848 13.4758H11.688C11.8185 13.4758 11.9235 13.3656 11.9235 13.2318V9.97305L14.3235 13.3735C14.3403 13.3961 14.36 13.4163 14.382 13.4333L14.3835 13.4349L14.3985 13.4443L14.4045 13.4475L14.4165 13.4538L14.427 13.4585L14.4345 13.4616L14.4495 13.4664H14.454C14.4736 13.4716 14.4937 13.4748 14.514 13.4758H15.354C15.4845 13.4758 15.5895 13.3656 15.5895 13.2318V7.74229C15.5895 7.67716 15.5648 7.6147 15.521 7.56864C15.4771 7.52258 15.4176 7.49671 15.3555 7.49671H14.514ZM20.2365 8.62546V7.74387C20.2367 7.71162 20.2308 7.67964 20.2193 7.64977C20.2077 7.61989 20.1906 7.5927 20.169 7.56975C20.1474 7.5468 20.1217 7.52854 20.0934 7.516C20.0651 7.50347 20.0347 7.49691 20.004 7.49671H16.641C16.5806 7.49759 16.5228 7.52232 16.479 7.56598H16.4775L16.476 7.56912L16.473 7.57385C16.4318 7.61939 16.4082 7.67947 16.407 7.74229V13.2302C16.407 13.2948 16.4325 13.3562 16.473 13.3987L16.476 13.4034L16.479 13.4065C16.523 13.4496 16.5808 13.4738 16.641 13.4742H20.004C20.133 13.4742 20.2365 13.364 20.2365 13.2287V12.3471C20.2367 12.3148 20.2308 12.2828 20.2193 12.253C20.2077 12.2231 20.1906 12.1959 20.169 12.1729C20.1474 12.15 20.1217 12.1317 20.0934 12.1192C20.0651 12.1067 20.0347 12.1001 20.004 12.0999H17.715V11.1726H20.0025C20.1315 11.1726 20.235 11.0624 20.235 10.9271V10.0455C20.2352 10.0132 20.2293 9.98123 20.2178 9.95136C20.2062 9.92148 20.1891 9.89429 20.1675 9.87134C20.1459 9.84839 20.1202 9.83013 20.0919 9.8176C20.0636 9.80506 20.0332 9.79851 20.0025 9.7983H17.715V8.87105H20.0025C20.1315 8.87105 20.235 8.76085 20.235 8.62546H20.2365Z"
              fill="#65558F"
            />
          </svg>

          <p>@fonduehelp</p>
        </a>
      </div>
    </div>
  );
}
